
import Vue from 'vue'
import TextExcerpt from '@/components/common/TextExcerpt.vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import {optionsVslim} from '@/config/v-slim-dialog'

const smsModule = namespace('sms')

@Component({
  components: {
    TextExcerpt,
    BaseSubNavContainer,
    BaseListItemContainer
  }
})
export default class ProspectBlocSms extends Vue {
  @smsModule.Action('getSmsBlocTextsAction') getSmsBlocTexts: any
  @smsModule.Action('getSmsBlocTextByIdAction') getSmsBlocTextById: any
  @smsModule.Action('deleteSmsBlocTextAction') deleteSmsBlocText: any
  @smsModule.Action('syncSmsBlocTextAction') syncSmsBlocText: any
  @smsModule.Getter('smsBlocTextsGetter') smsBlocTexts: any

  mounted() {
    this.getSmsBlocTexts()
  }

  changeOrder(data) {
    this.syncSmsBlocText(data)
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm('Confirmez vous la suppression du blocsms ?', optionsVslim)
    if (ok) {
      this.deleteSmsBlocText(id).then(async () => {
        this.getSmsBlocTexts()
      })
    }
  }
}
